import React from "react";
import { useSelector } from "react-redux";
import ShoppingCartModal from "./ShoppingCartModal";
import { ShoppingCart as CartIcon } from "lucide-react";
import "../../css/ShoppingCart.css";

const ShoppingCart = ({ showModal, setShowModal, menuId, restaurantId }) => {
  const cartItems = useSelector((state) => state.cart.cartItems);

  return (
    <div className="shopping-cart-container">
      <button onClick={() => setShowModal(true)} className="cart-icon-button">
        <CartIcon />
        {cartItems.length > 0 && (
          <span className="cart-badge">{cartItems.length}</span>
        )}
      </button>

      {showModal && (
        <ShoppingCartModal
          onClose={() => setShowModal(false)}
          menuId={menuId}
          restaurantId={restaurantId}
        />
      )}
    </div>
  );
};

export default ShoppingCart;
